/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListMusic = [
  ["path", { d: "M16 5H3" }],
  ["path", { d: "M11 12H3" }],
  ["path", { d: "M11 19H3" }],
  ["path", { d: "M21 16V5" }],
  ["circle", { cx: "18", cy: "16", r: "3" }]
];

export { ListMusic as default };
//# sourceMappingURL=list-music.js.map
